import { createReducer } from '@reduxjs/toolkit'
import {
  getWsTokenAction,
  updateLatencyAction,
  updatePingTimeAction,
  updatePongTimeAction,
  updateWsConnection,
  updateWsLostAction,
  updateWsTokenAction,
} from './actions'

export interface WsState {
  connection: number
  token: string
  pingTime: number
  pongTime: number
  lost: number
  latency: number
}
export const initialState: WsState = {
  connection: 0,
  token: '',
  pingTime: 0,
  pongTime: 0,
  lost: -1,
  latency: 0,
}
export default createReducer<WsState>(initialState, (builder) => {
  builder
    .addCase(updateWsConnection, (state, { payload }) => {
      state.connection = payload
    })
    .addCase(getWsTokenAction.fulfilled, (state, { payload }) => {
      state.token = payload
    })
    .addCase(updateWsTokenAction, (state, { payload }) => {
      state.token = payload
    })
    .addCase(updateWsLostAction, (state, { payload }) => {
      state.lost = payload
    })
    .addCase(updatePingTimeAction, (state, { payload }) => {
      state.lost = state.lost + 1
      state.pingTime = payload
    })
    .addCase(updatePongTimeAction, (state, { payload }) => {
      state.lost = -1
      state.latency = payload - state.pingTime
    })
    .addCase(updateLatencyAction, (state, { payload }) => {
      state.latency = payload
    })
})
